define('responsive-gameday/views/distributors/viewDistributors/InningPlaysDistributor',['require','exports','module','GameDayCore','jquery','./ViewDistributorBase','../../Monitor/Events/ViewModelUpdateEvents','message-service/message-service','../events/DistributionEvents','extant/extant','gameday-resource-path/gameday-resource-path','GameDayCore/GDModel/enums/baseball/GameStates'],function(require,exports,module) {
    var GDC = require("GameDayCore"),
        $ = require("jquery"),
        ViewDistributorClass = require("./ViewDistributorBase"),
        UpdateEvents = require("../../Monitor/Events/ViewModelUpdateEvents"),
        MessageService = require("message-service/message-service"),
        DistEvents = require("../events/DistributionEvents"),
        exists = require("extant/extant"),
        resourcePath = require("gameday-resource-path/gameday-resource-path"),
        GameStates = require("GameDayCore/GDModel/enums/baseball/GameStates");

    var Superclass;

    function InningPlaysDataPack(game){
        var that = this,
            liveData = game.liveData,
            gameData = game.gameData,
            plays = game.liveData.plays.playsByInning,
            inningsData = game.liveData.linescore.innings,
            teams = game.gameData.teams,
            homeID = teams.home.teamID.replace('ID','t'),
            awayID = teams.away.teamID.replace('ID','t'),
            play,
            innings = [],
            topBottom = {},
            i=0,
            len=plays.length;

        for(; i<len; i++){
            inning = plays[i];
            if(inning && inningsData[i]){
                innings.push({ 
                    inning : inningsData[i].num,
                    inningWithOrdinal : inningsData[i].ordinalNum,
                    halves : [{
                        half        : 'top',
                        plays       : inning.top,
                        cssTeamID   : awayID
                    },{
                        half        : 'bottom',
                        plays       : inning.bottom,
                        cssTeamID   : homeID

                    }]
                });
            }
        }
        this.currentInning = game.liveData.linescore.currentInning
        this.innings = innings;
        this.teams = teams;
    }

    InningPlaysDataPack.prototype.mugshot = function(){
        return resourcePath.get('mugshot',{ pid : this.id});
    };


    function InningPlaysDistributor(evt) {
        this.eventType = evt;
        Superclass.constructor.call(this,evt);

        MessageService.addListener.call(this, DistEvents.UPDATE_ALL, this.refresh);
        MessageService.addListener.call(this, UpdateEvents.REQUEST_INNING_DATA, this.handleUpdateRequest);
    }

    ViewDistributorClass.spawn(InningPlaysDistributor).define({
        prepDataForView: function() {
            this.dataPack = new InningPlaysDataPack(this.game);
            this.dispatchUpdates();
        }
    });

    Superclass = InningPlaysDistributor.superclass;

    return InningPlaysDistributor;
});

